import React from "react";
import { Sankey } from "@ant-design/charts";
import { Divider } from "antd";

const DropOff = (props) => {

    const { conversions = [] } = props;

    //       "checkout_conversions": {
    //     "item": 7,
    //     "cart": 20,
    //     "browse": 7,
    //     "checkout": 5,
    //     "purchase": 3,
    //     "lists": 1,
    //     "direct": 4,
    //     "home": 1
    //   },

    //  { source: "Home", target: "Cart", value: 50 },


    // [
    //         { source: "Home", target: "Cart", value: 50 },
    //         { source: "Browse", target: "Cart", value: 75 },
    //         { source: "Direct", target: "Cart", value: 50 },
    //         { source: "Other", target: "Cart", value: 25 },
    //         { source: "Cart", target: "Checkout", value: 100 },
    //         { source: "Checkout", target: "Purchase", value: 90 },
    //         { source: "Cart", target: "Exit", value: 100 },
    //         { source: "Checkout", target: "Exit", value: 10 },
    //     ]

    if(conversions.length === 0){
        return(<>nothing...</>)
    }

    const purchase = conversions.find(item => item.route === "purchase");
    const checkout = conversions.find(item => item.route === "checkout");
    const cart = conversions.find(item => item.route === "cart");



    const _data = conversions.filter(item => item !== "purchase").map((item, index) => {

        let _itm = {
            value: parseInt(conversions[index]?.count) || 0
        };

        switch (item.route) {
            case "checkout":
                _itm.source = "Checkout";
                _itm.target = "Purchase";
                _itm.value = parseInt(purchase.count);
                break;
            case "purchase":
                _itm.source = "Purchase";
                _itm.target = "Complete";
                break;
            case "cart":
                _itm.source = "Cart";
                _itm.target = "Checkout";
                _itm.value = parseInt(checkout.count);
                break;
            case "direct":
                _itm.source = "Direct";
                _itm.target = "Cart";
                break;
            case "home":
                _itm.source = "Home";
                _itm.target = "Cart";
                break;
            case "browse":
                _itm.source = "Browse";
                _itm.target = "Cart";
                break;
            case "item":
                _itm.source = "Product Page";
                _itm.target = "Cart";
                break;
            default:
                _itm.source = "Other";
                _itm.target = "Cart";
                break;
        }
        return _itm
    })

    _data.push(
        { source: "Cart", target: "Drop off", value: parseInt(cart.count - checkout.count) }
    )

    _data.push(
        { source: "Checkout", target: "Drop off", value: parseInt(checkout.count - purchase.count) }
    )


    const data = {
        type: "sankey",
        sourceField: "source",
        targetField: "target",
        weightField: "value",
        color: (_f) => {
            switch (_f.name) {
                case "Purchase":
                    return "#78d38a";
                case "Cart":
                    return "#78b2af";
                case "Checkout":
                    return "#6eb69a"
                case "Complete":
                    return "#64e764"
                case "Drop off":
                    return "#888";
                default:
                    return "#6082a1"
            }
        },

        data: _data,
    };

    return (
        <div>
            <strong className="c" style={{ "fontSize": "13px" }}>Conversions</strong>
            <div style={{ "fontSize": "14px" }}><small>How visitors progress from browsing to buying</small></div>
            <Divider dashed style={{ "margin": "10px 0px" }} />
            <Sankey {...data} height={400} />
        </div>
    )
};

export default DropOff;